import { render, staticRenderFns } from "./unallocated.vue?vue&type=template&id=5d677022&scoped=true"
import script from "./unallocated.vue?vue&type=script&lang=js"
export * from "./unallocated.vue?vue&type=script&lang=js"
import style0 from "./unallocated.vue?vue&type=style&index=0&id=5d677022&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d677022",
  null
  
)

export default component.exports